(function (window, document, cookieConsentName, dataLayerName) {
  window[cookieConsentName] = window[cookieConsentName] || {};
  window[dataLayerName] = window[dataLayerName] || [];

  const cookieConsent = window[cookieConsentName].consent;

  function handleUpdate(consent) {
    window[dataLayerName].push({ event: `${cookieConsentName}.update`, [cookieConsentName]: consent });
  }

  cookieConsent.subscribe(handleUpdate);
  window[dataLayerName].push({ [cookieConsentName]: cookieConsent.get() });
}(window, document, 'cookieConsent', 'dataLayer'));
